import { render, staticRenderFns } from "./webrtcVideo.vue?vue&type=template&id=4f0b2d6a&scoped=true"
import script from "./webrtcVideo.vue?vue&type=script&lang=js"
export * from "./webrtcVideo.vue?vue&type=script&lang=js"
import style0 from "./webrtcVideo.vue?vue&type=style&index=0&id=4f0b2d6a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0b2d6a",
  null
  
)

export default component.exports